import { useContext } from 'react';
import {
  AchievementContext,
  AchievementContextType,
} from '../contexts/AchievementContext';

export function useAchievements(): AchievementContextType {
  const context = useContext(AchievementContext);
  if (!context) {
    throw new Error(
      'useAchievements must be used within an AchievementProvider'
    );
  }
  return context;
}
